export default "__VITE_ASSET__B1nD8GOE__"